import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { HelpTooltip } from "../../Theme";
import HelpGuide from "@mui/icons-material/Help";
import VideoIcon from "@mui/icons-material/OndemandVideo";
import PdfIcon from "@mui/icons-material/PictureAsPdf";
interface Props {
  content?: any;
  pdf?: any;
  video?: any;
}

export const HelpGuideTooltip: React.FC<Props> = ({ content, pdf, video }) => {
  return (
    <HelpTooltip
      placement="right"
      arrow
      title={
        <>
          <Grid
            container
            item
            xs={12}
            spacing={1}
            alignItems="top"
            justifyContent="center"
          >
            <Grid item xs={12}>
              {content}
            </Grid>
            <Grid item xs={12}>
              <Box className="icons">
                {pdf && (
                  <>
                    <Tooltip placement="top" arrow title={"Document"}>
                      <IconButton target={"_blank"} href={pdf}>
                        <PdfIcon color="error" fontSize="large" />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
                {video && (
                  <>
                    <Tooltip placement="top" arrow title={"Video"}>
                      <IconButton target={"_blank"} href={video}>
                        <VideoIcon color="primary" fontSize="large" />
                      </IconButton>
                    </Tooltip>
                  </>
                )}
              </Box>
            </Grid>
          </Grid>
        </>
      }
    >
      <HelpGuide style={{ margin: 5, marginBottom: 0 }} />
    </HelpTooltip>
  );
};
